import React, { useEffect, useState } from "react";
// import { Form } from "react-bootstrap";

import validator from "validator";

import Minus from "../../assets/sinner/minus.png";
import style from "./styles.module.scss";

/****
 * this component render signers form , in document signing flow,
 * eg- adds multiple signers on button click
 */
function SignersField({
  item,
  removeSigner,
  index,
  signerFields,
  setSignerFields,
  isEdit,
}) {
  // const [user] = useLocalStorage(KEY_USER);
  const [error, setError] = useState({
    name: null,
    email: null,
  });
  const user = JSON.parse(localStorage.getItem("auth"))?.results || {};

  const handleNameOnBlur = () => {
    if (item.name?.length < 3) {
      setError({ ...error, name: "Name should be at least 3 characters" });
      item.nameError = "Name should be at least 3 characters";
      item.isValidated = false;
    } else {
      setError({ ...error, name: null });
      item.nameError = null;
    }
    if (
      error.email === null &&
      error.name === null &&
      item.name.length > 1 &&
      validator.isEmail(item.email)
    ) {
      item.isValidated = true;
    }
  };

  const handleEmailOnBlur = () => {
    const isValidEmail = validator.isEmail(item.email);
    if (isValidEmail) {
      let isDuplicate = false;

      signerFields.forEach((element) => {
        if (
          element.id !== item.id &&
          element.email.toLowerCase() === item.email.toLowerCase()
        ) {
          isDuplicate = true;
          return;
        }
      });
      if (isDuplicate) {
        setError({ ...error, email: "Duplicate email found" });
        item.emailError = "Duplicate email found";
        return;
      }

      if (!isEdit) {
        if (item.email.toLowerCase() === user.email.toLowerCase()) {
          setError({
            ...error,
            email:
              "You cannot use loggedIn Email, select `are you a signer?` option Instead.",
          });
          item.emailError =
            "You cannot use loggedIn Email, select `are you a signer?` option Instead.";
          return;
        }
      }

      setError({ ...error, email: null });
      item.emailError = null;
    } else {
      setError({ ...error, email: "Valid Email format is required" });
      item.emailError = "Valid email is required";
      item.isValidated = false;
    }
  };

  useEffect(() => {
    if (
      error.email === null &&
      error.name === null &&
      item?.name?.length > 1 &&
      item?.email?.length > 1
    ) {
      item.isValidated = true;
    } else {
      item.isValidated = false;
    }
  }, [error]);

  return (
    <div className={`${style.form_main_box}`}>
      <h5>
        {item?.isValidated ? "Selected signer" : `Additional signer`} ({index})
      </h5>
      <form controlId='formBasicEmail'>
        <div className={`${style.position_minus}`}>
          <img
            alt='logo'
            className='App-logo'
            onClick={() => removeSigner(item.id)}
            src={Minus}
            style={{ cursor: "pointer" }}
            title='Remove '
          />
        </div>
        <label>Full name</label>
        <input
          onBlur={handleNameOnBlur}
          disabled={item?.isValidated ? true : false}
          onChange={(e) =>
            setSignerFields((preVal) => {
              preVal[index > 0 ? index - 1 : 0] = {
                ...preVal[index > 0 ? index - 1 : 0],
                name: e.target.value.trim(),
              };
              return [...preVal];
            })
          }
          value={item?.name}
          placeholder='Enter name'
          type='name'
        />
        {item.nameError && <p className='text-danger'>{item.nameError}</p>}
      </form>
      <form controlId='formBasicEmail'>
        <label>Email address</label>
        <input
          onBlur={handleEmailOnBlur}
          // onChange={(e) => (item.email = e.target.value)}
          disabled={item?.isValidated ? true : false}
          onChange={(e) =>
            setSignerFields((preVal) => {
              preVal[index > 0 ? index - 1 : 0] = {
                ...preVal[index > 0 ? index - 1 : 0],
                email: e.target.value.trim(),
              };
              return [...preVal];
            })
          }
          value={item?.email}
          placeholder='Enter email'
          type='email'
        />
        {item.emailError && <p className='text-danger'>{item.emailError}</p>}
      </form>
    </div>
  );
}

export default SignersField;
